<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-20 10:27:47
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-20 15:06:16
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/components/bindAccount.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <vab-query-form class="ml-10">
      <vab-query-form-right-panel :span="24">
        <el-button type="primary" @click="handleAdd">添加管理员</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>
    <div class="containerForm">
      <el-table v-loading="listLoading" border :data="tableData">
        <el-table-column label="序号" type="index" width="50" />
        <el-table-column label="姓名" prop="name" show-overflow-tooltip />
        <el-table-column label="国际区号" prop="phoneCountryCode" show-overflow-tooltip />
        <el-table-column label="手机号码" prop="phone" show-overflow-tooltip />
        <el-table-column label="操作" show-overflow-tooltip width="420">
          <template #default="{ row }">
            <el-button type="danger" @click="delBind(row, $event)">取消绑定</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <!-- <el-image
                class="vab-data-empty"
                :src="require('@/assets/empty_images/data_empty.png')"
              /> -->
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>

      <!-- <el-pagination background :current-page="form.pageNum" :layout="layout" :page-size="form.pageSize" :total="total" @current-change="handleCurrentChange" @size-change="handleSizeChange" /> -->
    </div>

    <el-drawer v-model="innerDrawer" :append-to-body="true" :before-close="handleCloseInner" title="添加管理员">
      <el-form ref="formRef" :model="queryForm" :rules="rules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="queryForm.name" placeholder="请输入用户姓名" />
        </el-form-item>
        <el-form-item label="区号" prop="phoneCountryCode">
          <el-select v-model="queryForm.phoneCountryCode" placeholder="请选择地区">
            <el-option
              v-for="(item, index) in counrtyList"
              :key="item.countryPhoneCode"
              :label="item.country + item.countryPhoneCode"
              :value="item.countryPhoneCode"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="queryForm.phone" />
        </el-form-item>

        <el-form-item>
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { countryQueryInfo } from '@/api/brand'
  import {
    getEnterpriseMarketingQueryDistribution,
    enterpriseChannelUser,
    delEnterpriseChannelUser,
  } from '@/api/channel'
  export default defineComponent({
    name: 'EditConfigDrawer',

    setup(props, { emit }) {
      /**
       * @description: cover主k 自定义校验
       * @return {*}
       */

      const { proxy } = getCurrentInstance()
      const state = reactive({
        form: {
          pageNum: 1,
          pageSize: 10,
          phone: '',
          code: '',
        },
        filterSelectStatus: {
          CANCEL_SIGN: '自主取消',
          ACCEPT: '通过',
          REFUSE: '拒绝',
          PENDING_REVIEW: '审核中',
          NOT_REVIEW: '通过',
        },
        userType: [
          {
            label: '全部',
            value: '',
          },
          {
            label: '标准版',
            value: 'ENTERPRISE',
          },
          {
            label: '高级版',
            value: 'PERSONAL',
          },
        ],
        dialogFormVisible: false,
        direction: 'rtl',
        size: '60%',
        pararms: {
          type: 'MEETING_REGISTER_REPORT',
        },
        title: '绑定管理员',
        tableData: [],
        isCheck: false,
        visible: false,
        checkRow: {},
        total: 0,
        list: [],
        layout: 'prev, pager, next',
        meetingType: '',
        innerDrawer: false,
        queryForm: { phone: '', phoneCountryCode: '', name: '' },
        formRef: null,
        rules: {
          phoneCountryCode: [{ required: true, trigger: 'change', message: '请选择区号' }],
          phone: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
          name: [{ required: true, trigger: 'blur', message: '请输入姓名' }],
        },
        counrtyList: [],
        // exportLoading: false,
      })

      // 打开
      const handleOpen = async (row = {}, meetingType) => {
        state.queryForm.channelId = row.id
        state.meetingType = meetingType
        state.form = Object.assign(state.form, {})
        const { data: country } = await countryQueryInfo()
        console.log(country)
        state.counrtyList = country
        state.dialogFormVisible = true
        getData()
      }

      const getData = async () => {
        const { data } = await getEnterpriseMarketingQueryDistribution(state.queryForm.channelId)
        console.log(data)
        state.tableData = data
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const exportFile = (row) => {
        window.open(row.exportParams.fileUrl)
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      // 查询
      const handleQueryData = () => {
        state.form.pageNum = 1
        getData()
      }
      // 条数
      const handleSizeChange = (pageSize) => {
        state.form.pageSize = pageSize
        getData()
      }

      const handleCurrentChange = (pageNum) => {
        state.form.pageNum = pageNum
        getData()
      }

      const handleAdd = () => {
        state.innerDrawer = true
      }

      const save = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            try {
              const { data } = await enterpriseChannelUser(state.queryForm)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
              getData()
              state.innerDrawer = false
            } catch (error) {}
          }
        })
      }

      const delBind = (row) => {
        if (row.uid) {
          proxy.$baseConfirm('请确认您要删除这个负责人账号的渠道绑定权限', null, async () => {
            const { msg } = await delEnterpriseChannelUser(state.queryForm.channelId, row.uid)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await getData()
          })
        }
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        exportFile,
        handleDate,
        handleQueryData,
        handleSizeChange,
        handleCurrentChange,
        handleAdd,
        save,
        delBind,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    width: 100%;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
